import { useTechnologicalTransferDelete } from '@/module/Author/TechnologicalTransfer';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface TechnologicalTransferDeleteButtonProps {
  technologicalTransferId: Id;
}

export function TechnologicalTransferDeleteButton({ technologicalTransferId }: TechnologicalTransferDeleteButtonProps) {
  const mutation = useTechnologicalTransferDelete(technologicalTransferId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
